export default __webpack_public_path__ + "static/spatiul-verde-m-be35395bdc0c5d204578919bd3924d52.jpg";